import React, { createContext, useContext } from 'react';
const AppStateContext = createContext(null);
export function AppStateProvider(props) {
    return React.createElement(AppStateContext.Provider, { value: props.value }, props.children);
}
export function useStores() {
    const ctx = useContext(AppStateContext);
    if (ctx === null) {
        throw new Error('useStores must be called inside <AppStateProvider>');
    }
    return ctx.stores;
}
//# sourceMappingURL=react.js.map